export default __webpack_public_path__ + "static/media/cricket.dc64d4c9.png";